// extracted by mini-css-extract-plugin
export var layout = "ReferenceLayout-module--layout--7ffb9";
export var sidebar = "ReferenceLayout-module--sidebar--0a19f";